export const quranTrackingFr = {
  // Quran progress
  lastSession: 'Dernière Séance',
  nextSession: 'Prochaine Séance',
  note: 'Note',
  
  // Hifz - Mémorisation
  newHifzTxt: 'Mémorisation Nouvelle',
  nextHalaqaNewHifzText: 'Mémorisation pour la Prochaine Séance',
  
  // Murajah - Révision
  oldHifzMurajahTxt: 'Révision Ancien Hifz',
  newHifzMurajahText: 'Révision Nouveau Hifz',
  nextHalaqaOldHifzMurajahText: 'Révision Ancien Hifz pour la Prochaine Séance',
  nextHalaqaNewHifzMurajahText: 'Révision Nouveau Hifz pour la Prochaine Séance',

  // Actions & labels
  absent: 'Absent(e)',
  edit: 'Modifier',
  cancel: 'Annuler',
  save: 'Enregistrer',
  saving: 'En cours...',
  savingEvals: 'Enregistrement...',
  evaluation: 'Évaluation',
  repeatLastHifz: 'Répétition Dernier Hifz',
  repeatNewHifzLabel: 'Répétition Nouveau Hifz',
  times: 'fois',
  mustRepeatPart1: "L'élève doit répéter le nouveau Hifz",
  mustRepeatPart2: 'puis mettre à jour la valeur',
  sortByLastSession: 'Date dernière séance',

  // Evaluation options
  evalExcellent: 'Excellent',
  evalGood: 'Bien',
  evalMoyen: 'Moyen',
  evalRepeat: 'À refaire',
  evalAbsent: 'Absent(e)',
  evalNotDone: 'Non effectué',
};
